import React from 'react';
import LOOKUP from 'constants/lookup';
import TextInput from 'screens/components/basic/TextInput';
import SelectInput from 'screens/components/basic/SelectInput';
import Button from 'screens/components/basic/Button';
import RadioInput from 'screens/components/basic/RadioInput';
import CardSimple from 'screens/components/basic/CardSimple';

const SearchFields = (props) => {
    return (
        <CardSimple>
            <div className="row">
                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12 col-12">
                        <TextInput
                            name={`${props.pageName}Name`}
                            className="search-field"
                            label={LOOKUP.menu.admin.marketing.name.label}
                            floatingLabelText={LOOKUP.menu.admin.marketing.name.label}
                            hintText={LOOKUP.menu.admin.marketing.name.hintText}
                            maxLength={20} 
                            onPressKey={props.search}/>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12 col-12">
                        <TextInput
                            name={`${props.pageName}LastName`}
                            className="search-field"
                            label={LOOKUP.menu.admin.marketing.lastName.label}
                            floatingLabelText={LOOKUP.menu.admin.marketing.lastName.label}
                            hintText={LOOKUP.menu.admin.marketing.lastName.hintText}
                            maxLength={20} 
                            onPressKey={props.search}/>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12 col-12">
                        <TextInput
                            name={`${props.pageName}Email`}
                            className="search-field"
                            label={LOOKUP.menu.admin.marketing.email.label}
                            floatingLabelText={LOOKUP.menu.admin.marketing.email.label}
                            hintText={LOOKUP.menu.admin.marketing.email.hintText}
                            maxLength={20} 
                            onPressKey={props.search}/>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12 col-12">
                        <TextInput
                            type={"number"}
                            name={`${props.pageName}PhoneNumber`}
                            className="search-field"
                            label={LOOKUP.menu.admin.marketing.phoneNumber.label}
                            floatingLabelText={LOOKUP.menu.admin.marketing.phoneNumber.label}
                            hintText={LOOKUP.menu.admin.marketing.phoneNumber.hintText}
                            maxLength={20} 
                            onPressKey={props.search}/>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12 col-12">
                        <SelectInput name={`${props.pageName}Genger`}
                            className="search-field"
                            label={LOOKUP.menu.admin.marketing.gender.label}
                            floatingLabelText={LOOKUP.menu.admin.marketing.gender.label}
                            hintText={LOOKUP.menu.admin.marketing.gender.hintText}
                            options={LOOKUP.common.genders}
                        />
                    </div>
                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 pb-2 pt-1 text-right">
                        <Button 
                            type="IconSearchButton"
                            mini={true}
                            label={LOOKUP.patient.filters.filterButton}
                            onTouchTap={() => props.search()} 
                        />
                        <Button 
                            className="ml-2"
                            type="IconClearButton"
                            label={LOOKUP.patient.filters.cleanFilterButton}
                            onTouchTap={() => props.cleanSearch()} 
                        />
                    </div>
            </div>
        </CardSimple>
    );
};


export default SearchFields;